import { RadioButtons } from "@stacc/flow-ui-components";
import {
  FormComponentContainer,
  StyledErrorContainer,
  StyledErrorLabel
} from "./styles";

type RadioButtonGroupProps = {
  radioButtonValue: boolean | string | number | null;
  onChange: (value: any) => void;
  title: string;
  options: { value: boolean | string | number; label: string }[];
  id: string;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
};

export const RadioButtonGroup = (props: RadioButtonGroupProps) => {
  return (
    <FormComponentContainer>
      <div style={{ fontWeight: "600", maxWidth: "300px" }}>{props.title}</div>
      <RadioButtons
        options={props.options}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          props.onChange(e.target.value)
        }
        name={props.id}
        checkedValue={props.radioButtonValue ?? ""}
        disabled={props?.disabled}
      />
      {props.hasError && props.errorMessage && (
        <StyledErrorContainer>
          <StyledErrorLabel>{props.errorMessage}</StyledErrorLabel>
        </StyledErrorContainer>
      )}
    </FormComponentContainer>
  );
};
